import { Message,  Notification, MessageBox} from 'element-ui'
/*
对Element-ui的各种提示消息框进行封装
Message: 一般主动操作消息提示，下一条会覆盖上一条
Notification: 一般系统消息提示，可以显示多条
四种状态：success/warning/info/error

请求：
  成功状态，提示type:success/info
  失败/警告状态,提示type: warnning/error
  duration: 设置为0则不会自动关闭
  notification的position属性：top-right/top-left/bottom-right/bottom-left
 */

const msg = new Object();

function generate_type(type) {
  if (type[0] === 's') {
    type = 'success'
  } else if (type[0] === 'w') {
    type = 'warning'
  } else if (type[0] === 'e') {
    type = 'error'
  } else {
    type = 'info'
  }
  return type
}
msg.msg = function (msg, type='success', duration=3000) {
  Message({
    type: generate_type(type),
    message: msg,
    duration: duration
  })
};

msg.notify = function (msg, title='', type='success', duration=3000, position='top-right') {
  let config = {
    message: msg,
    type: generate_type(type),
    duration: duration,
    position: position
  };
  if (title) {config.title = title}
  return Notification(config);
};

msg.alert = function (msg, title='错误', type='error', confirmButtonText='确定'){
  MessageBox.alert(msg, title, {
    confirmButtonText: confirmButtonText,
    type: generate_type(type)
  })
}
export default msg;




// WEBPACK FOOTER //
// ./src/utils/msg.js